import axios, { CancelTokenSource } from "axios";
import { GetBackendUrlForGlobalFunctions } from "../../App";
import { UpdateBreakInType } from "../../utils/Types/types";

export const GetCloudExecutionDatasByPlan = (
  id: number,
  isBreakIn:boolean,
  tokenSource?: CancelTokenSource
) => {
  var query = GetBackendUrlForGlobalFunctions() + `cloud-execution/${id}?isBreakIn=${isBreakIn}`;
  return axios.get(query, {
    headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache', Expires: '0' },
    cancelToken: tokenSource?.token,
  });
};

export const updateBreakIn = (obj: UpdateBreakInType[]) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `cloud-execution`,
    obj,
    {
      headers,
    }
  );
};